var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirshipinline = function SvgAirshipinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2A55DD",
    d: "M7.99 2.162 0 10.44l2.841 2.944.022.022c1.246-1.496 3.09-2.445 5.148-2.445a6.6 6.6 0 0 1 3.817 1.215q.148.106.29.217.573.45 1.041 1.013L16 10.462l-.997-1.032zM8 5.554c.446 0 .806.373.806.835s-.36.835-.806.835c-.445 0-.805-.374-.805-.835 0-.462.36-.835.805-.835m5.171 6.903a7.5 7.5 0 0 0-1.657-1.25 7.201 7.201 0 0 0-6.259-.359 10.17 10.17 0 0 1 8.468-1.81l.828.858.546.565z"
  })));
};
export default SvgAirshipinline;